import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { connectAuthEmulator } from 'firebase/auth';
import { connectFirestoreEmulator } from 'firebase/firestore';
import { connectStorageEmulator } from 'firebase/storage';
import { getCurrentEnvironment, subscribeToEnvChanges } from './environment';

// Get the current environment config
const env = getCurrentEnvironment();
let firebaseConfig = env.firebase;

// Initialize Firebase with the current environment
const app = initializeApp(firebaseConfig);
console.log('email test here - Firebase project config', {
  projectId: firebaseConfig?.projectId,
  authDomain: firebaseConfig?.authDomain
});

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to local emulators if in development mode
// @ts-ignore - Vite provides these at runtime
if (env.name === 'development' && import.meta.env.VITE_USE_EMULATORS === 'true') {
  // Get the emulator host (default: localhost)
  // @ts-ignore - Vite provides these at runtime
  const host = import.meta.env.VITE_EMULATOR_HOST || 'localhost';
  
  // Connect to Auth emulator
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  console.log('email test here - Connected to Firebase Auth emulator');
  
  // Connect to Firestore emulator
  connectFirestoreEmulator(db, host, 8080);
  console.log('email test here - Connected to Firestore emulator');
  
  // Connect to Functions emulator
  connectFunctionsEmulator(functions, host, 5001);
  console.log('email test here - Connected to Functions emulator');
  
  // Connect to Storage emulator
  connectStorageEmulator(storage, host, 9199);
  console.log('email test here - Connected to Storage emulator');
}
else {
  console.log('email test here - Using Firebase production services (no emulators)');
}

// Subscribe to environment changes
subscribeToEnvChanges((newEnv) => {
  console.log('Environment changed to:', newEnv.name);
  // You can handle Firebase reconnection here if needed
  // For safety, we'll reload the page to ensure clean reconnection
  if (window.location.hostname !== 'localhost') {
    // Only reload in non-local environments to prevent development disruption
    window.location.reload();
  }
});
